/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetInvoiceDocumentFile$Params {

/**
 * Identifier of the invoice document
 */
  uuid: string;
      body: {

/**
 * Key identifying the file in storage
 */
'fileKey'?: string;
}
}

export function getInvoiceDocumentFile(http: HttpClient, rootUrl: string, params: GetInvoiceDocumentFile$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, getInvoiceDocumentFile.PATH, 'post');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

getInvoiceDocumentFile.PATH = '/invoice-document/{uuid}/file';
